import React from "react";
import Navbar from "../components/Navbar/Navbar";

interface RegistrationLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<RegistrationLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-100">
      <Navbar />
      {children}
    </div>
  );
};

export default MainLayout;
